import { render } from "./FishButton.vue?vue&type=template&id=cc744ee2&scoped=true"
import script from "./FishButton.vue?vue&type=script&lang=js"
export * from "./FishButton.vue?vue&type=script&lang=js"

import "./FishButton.vue?vue&type=style&index=0&id=cc744ee2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc744ee2"]])

export default __exports__